import React, { FunctionComponent } from 'react';
import { InfoIcon } from '../SvgIcons';

// Import Local Styles
import styles from './infoBanner.module.css';

export interface AlertBannerProps {
  text: string;
  success?: boolean;
}

export const InfoBanner: FunctionComponent<AlertBannerProps> = (props) => {
  const { text, success } = props;

  return (
    <>
      <div className={`${styles.wrapper} ${success && styles.green}`}>
        <div className={styles.message}>
          <InfoIcon />
          {text}
        </div>
      </div>
    </>
  );
};
